import Hero from "../components/Hero";
import Service from "../components/Service";
import Counters from "../components/Counters";
import About from "../components/About";
import Banner from "../components/Banner";
import Projects from "../components/Projects";
import Info from "../components/Info";
import Testimonial from "../components/Testimonial";
import Footer from "../components/Footer";
import ContactUs from "../components/ContactUs";
import ScrollTop from "../components/ScrollTop";


function Home() {
  return (
    <>
      <Hero />
      <About />
    <Counters />
      <Service />
      <Banner />
      <Projects />
      <Info />
      <Testimonial />
      <ContactUs />
      <Footer />
      <ScrollTop />
    </>
  );
}

export default Home;
